import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';

import { HeaderButtonComponent } from './header-button.component';
import { TypographyComponentModule } from '../typography/typography.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [HeaderButtonComponent],
  imports: [CommonModule, ButtonModule, TypographyComponentModule],
  exports: [HeaderButtonComponent],
})
export class HeaderButtonComponentModule {}
